import { Box } from '@mui/material';

import type { Hour } from '../types';
import { durationToPixels, formatTime, hourToPixels } from '../utils';

type DropGhostProps = {
  start: Hour;
  duration: Hour;
  baseHour: Hour;
  slotHeight: number;
  hasConflict: boolean;
};

export function DropGhost({ start, duration, baseHour, slotHeight, hasConflict }: DropGhostProps) {
  const top = hourToPixels(start, baseHour, slotHeight);
  const height = Math.max(durationToPixels(duration, slotHeight) - 2, 18);

  return (
    <Box
      sx={{
        position: 'absolute',
        top,
        height,
        left: 4,
        right: 4,
        borderRadius: '5px',
        pointerEvents: 'none',
        zIndex: 3,
        display: 'flex',
        alignItems: 'flex-start',
        padding: '4px 7px',
        fontSize: 10,
        fontWeight: 600,
        background: hasConflict ? '#fce8c8' : '#d8e8c8',
        boxShadow: hasConflict ? 'inset 0 0 0 1px #b58a1e' : 'inset 0 0 0 1px #5e8f3e',
        color: hasConflict ? '#8a6a20' : '#2a3a22',
      }}
    >
      {formatTime(start)}
    </Box>
  );
}
